module.exports = __webpack_public_path__ + "static/media/back-forth.356fe0e8.svg";